<template>
  <div class="workbench-container">
    <Header />
    <div class="workbench-content">
      <!-- 统计卡片区域 -->
      <div class="stats-section">
        <div class="stat-card" v-for="(stat, index) in stats" :key="index">
          <div class="stat-header">
            <div class="stat-icon-wrapper">
              <div class="stat-icon-bg"></div>
              <div class="stat-icon">
                <img :src="stat.icon" alt="" />
              </div>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ stat.value }}</div>
              <div class="stat-label">
                {{ stat.label }}{{ stat.unit || "" }}
              </div>
            </div>
          </div>
          <!-- 状态数据 -->
          <div class="stat-footer" v-if="stat.statusItems && stat.statusItems.length > 0">
            <span class="status-item" :class="item.type" v-for="(item, idx) in stat.statusItems" :key="idx">
              <span class="status-label">{{ item.label }}</span>
              <span class="status-value">{{ item.value }}</span>
            </span>
          </div>
          <!-- 趋势数据 -->
          <div class="stat-footer trend-footer" v-else-if="stat.trend">
            <div class="trend-item" :class="stat.trend.type">
              <!-- 上升趋势图标 -->
              <svg v-if="stat.trend.type === 'up'" class="trend-icon" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M3 17L9 11L13 15L21 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M21 7H15V13" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <!-- 下降趋势图标 -->
              <svg v-else class="trend-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 7L9 13L13 9L21 17" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M21 17H15V11" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <span class="trend-value" :class="stat.trend.type">{{
                stat.trend.value
              }}</span>
              <span class="trend-label">{{ stat.trend.label }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 主要内容区域 -->
      <div class="main-content">
        <!-- 左侧：待办农事任务 -->
        <div class="left-panel panel-card">
          <div class="section-title">
            待办农事任务
            <div class="view-all" @click="toAlltest">查看全部</div>
          </div>
          <div class="task-grid" v-if="
            taskList &&
            taskList.length &&
            getAllMenuCodes.includes('yjKDdVwX')
          ">
            <div class="task-item" v-for="(task, index) in taskList" :key="index">
              <div class="task-header">
                <div class="task-title-section">
                  <span class="task-urgency" v-if="task.urgency">{{
                    task.urgency
                  }}</span>
                  <span class="task-name">{{ task.name }}</span>
                </div>
                <div class="task-time">{{ task.time }}</div>
              </div>
              <div class="task-content">
                <div class="task-desc">{{ task.description }}</div>
              </div>
              <div class="task-footer">
                <div class="task-assignee">
                  <div class="assignee-avatar">
                    <img :src="task.assigneeAvatar" alt="" v-if="task.assigneeAvatar" />
                    <div class="avatar-placeholder" v-else>
                      {{ task.assigneeName ? task.assigneeName.charAt(0) : "" }}
                    </div>
                  </div>
                  <span class="assignee-name">{{ task.assigneeName }}</span>
                </div>
                <el-button type="primary" size="mini" @click="handleExecuteTask(task, index)" class="execute-btn">
                  去执行
                </el-button>
              </div>
            </div>
          </div>
          <div class="empty-state" v-else>
            <img :src="emptyImage" alt="暂无待办任务" />
            <div class="empty-text">
              {{
                getAllMenuCodes.includes("yjKDdVwX")
                  ? "您没有待办任务"
                  : "暂无权限,无法查看待办任务"
              }}
            </div>
          </div>
        </div>

        <!-- 右侧：近期操作日志 -->
        <div class="right-panel panel-card">
          <div class="section-title">
            近期操作日志
            <div class="view-all" @click="toAllinfo">查看全部</div>
          </div>
          <div class="log-list" v-if="logList && logList.length">
            <div class="log-item" v-for="(log, index) in logList" :key="index">
              <div class="log-icon">
                <img :src="log.icon" alt="" />
              </div>
              <div class="log-content-wrapper">
                <div class="log-header">
                  <div class="log-title">{{ log.title }}</div>
                  <div class="log-time">{{ log.time }}</div>
                </div>
                <div class="log-desc">{{ log.description }}</div>
              </div>
            </div>
          </div>
          <div class="empty-state" v-else>
            <img :src="emptyImage" alt="暂无操作日志" />
            <div class="empty-text">暂无操作日志</div>
          </div>
        </div>
      </div>
    </div>
    <TaskExecutionDialog :visible.sync="taskDialogVisible" :taskData="selectedTask || {}" :mode="dialogMode"
      @success="handleTaskDialogSuccess" />
  </div>
</template>

<script>
import dayjs from "dayjs";
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";
import {
  getTodayOperationStatistics,
  getRecentOperationLog,
} from "@/api/workbench";
import Header from "./Header.vue";
import TaskExecutionDialog from "./techFarm/components/TaskExecutionDialog.vue";
import tip1 from "@/assets/img/workbench/tip1.png";
import tip2 from "@/assets/img/workbench/tip2.png";
import tip3 from "@/assets/img/workbench/tip3.png";
import tip4 from "@/assets/img/workbench/tip4.png";
import info1 from "@/assets/img/workbench/info1.png";
import info2 from "@/assets/img/workbench/info2.png";
import info3 from "@/assets/img/workbench/info3.png";
import info4 from "@/assets/img/workbench/info4.png";
import emptyImage from "@/assets/img/workbench/empty.png";
import { mapGetters } from "vuex";
export default {
  name: "StrawberryaiPcWorkbench",
  components: {
    Header,
    TaskExecutionDialog,
  },
  computed: {
    ...mapGetters("user", ["getAllMenuCodes"]),
  },
  data() {
    return {
      stats: [
        {
          icon: tip1,
          value: "0",
          label: "监测设备总数",
          unit: " (个)",
          statusItems: [
            { label: "正常", value: 0, type: "normal" },
            { label: "离线", value: 0, type: "offline" },
          ],
        },
        {
          icon: tip2,
          value: "0",
          label: "智控设备总数",
          unit: " (个)",
          statusItems: [
            { label: "远程", value: 0, type: "normal" },
            { label: "本地", value: 0, type: "offline" },
          ],
        },
        {
          icon: tip3,
          value: "0",
          label: "待办农事任务",
          unit: " (个)",
          statusItems: [
            { label: "紧急", value: 0, type: "offline" },
            { label: "常规", value: 0, type: "locked" },
            { label: "今日", value: 0, type: "normal" },
          ],
        },
        {
          icon: tip4,
          value: "0",
          label: "今日登录操作次数",
          unit: "",
          trend: {
            type: "up",
            value: "0%",
            label: "较上月",
          },
        },
      ],
      taskList: [],
      taskDialogVisible: false,
      selectedTask: null,
      dialogMode: "execute",
      logList: [

      ],
      emptyImage,
      operationStatsTimer: null, // 操作统计轮询定时器
    };
  },

  mounted() {
    this.fetchStats();
    this.fetchTaskList();
    this.fetchLogList();
    this.fetchOperationStats(); // 立即获取一次
    this.startOperationStatsPolling(); // 开始轮询
  },

  beforeDestroy() {
    // 清除轮询定时器
    if (this.operationStatsTimer) {
      clearInterval(this.operationStatsTimer);
      this.operationStatsTimer = null;
    }
  },

  methods: {
    // 获取统计数据
    async fetchStats() {
      try {
        const res = await axios.post(
          baseUrl + "/api/smart-workbench/statistical-overview"
        );
        if (res.code === 200 && res.data) {
          // 监控设备统计
          this.stats[0].value = res.data.monitoringDeviceCount || 0;
          this.stats[0].statusItems = [
            {
              label: "正常",
              value: res.data.monitoringDeviceOnlineCount || 0,
              type: "normal",
            },
            {
              label: "离线",
              value: res.data.monitoringDeviceOfflineCount || 0,
              type: "offline",
            },
          ];

          // 智控设备统计
          this.stats[1].value = res.data.controlDeviceCount || 0;
          this.stats[1].statusItems = [
            {
              label: "远程",
              value: res.data.controlDeviceRemoteCount || 0,
              type: "normal",
            },
            {
              label: "本地",
              value: res.data.controlDeviceLocalCount || 0,
              type: "offline",
            },
          ];

          // 待办农事任务统计
          this.stats[2].value = res.data.farmingTaskCount || 0;
          this.stats[2].statusItems = [
            {
              label: "紧急",
              value: res.data.farmingUrgentCount || 0,
              type: "offline",
            },
            {
              label: "常规",
              value: res.data.farmingNormalCount || 0,
              type: "locked",
            },
            {
              label: "今日",
              value: res.data.farmingTodayCount || 0,
              type: "normal",
            },
          ];
        }
      } catch (error) {
        console.error("获取统计数据失败:", error);
      }
    },
    // 获取待办任务列表
    async fetchTaskList() {
      try {
        const params = {
          page: 1,
          pageSize: 9,
          execStatusList: ["WAITING", "DELAYED"],
        };
        const res = await axios.post(
          baseUrl + "/api/digital-farming/task/allot-record/list-page",
          params
        );
        if (res.code === 200) {
          this.taskList = (res.data.list || []).map((item) =>
            this.transformTask(item)
          );
        }
      } catch (error) {
        console.error("获取待办任务列表失败:", error);
      }
    },
    // 获取操作日志列表
    async fetchLogList() {
      try {
        const res = await getRecentOperationLog();
        if (res.code === 200 && res.data) {
          this.logList = res.data.map((item) => this.transformLogItem(item));
        }
      } catch (error) {
        console.error("获取操作日志列表失败:", error);
      }
    },
    // 转换日志数据格式
    transformLogItem(item) {
      // 根据业务类型设置图标
      let icon = info1;
      if (item.businessType === "任务") {
        icon = info2;
      } else if (item.businessType === "报警") {
        icon = info3;
      } else if (item.businessType === "配置") {
        icon = info4;
      }

      return {
        type: item.businessType || "其他",
        icon: icon,
        title: item.operMethod || "操作",
        time: this.formatLogTime(item.createTime),
        description: item.description || `${item.userNickName}进行了操作`,
      };
    },
    // 格式化日志时间
    formatLogTime(createTime) {
      if (!createTime) return "--";
      const logDate = dayjs(createTime);
      const today = dayjs().startOf("day");
      const yesterday = dayjs().subtract(1, "day").startOf("day");

      if (logDate.isSame(today, "day")) {
        return "今天 " + logDate.format("HH:mm");
      } else if (logDate.isSame(yesterday, "day")) {
        return "昨天 " + logDate.format("HH:mm");
      } else {
        return logDate.format("MM月DD日 HH:mm");
      }
    },
    // 执行任务
    handleExecuteTask(task) {
      if (!this.getAllMenuCodes.includes('fCxBreY1')) {
        this.$message.warning("当前用户没有执行任务的权限");
        return;
      }
      if (!task || !task.id) {
        this.$message.warning("当前任务缺少编号，已为您打开任务列表");
        this.toAlltest();
        return;
      }
      this.selectedTask = { ...task };
      this.dialogMode = task.execStatus === "COMPLETED" ? "view" : "execute";
      this.taskDialogVisible = true;
    },
    toAlltest() {
      this.$router.push({
        path: "/techFarm/history",
        query: { menu: "tesk", taskTab: "history" },
      });
    },
    toAllinfo() {
      this.$router.push("/actionLog");
    },
    transformTask(task) {
      const urgency =
        task.execStatus === "DELAYED" || task.canExec === 0 ? "紧急" : "";
      return {
        ...task,
        urgency,
        name: task.greenhouseName,
        time: this.formatExecTime(task.execStartDate, task.execEndDate),
        description: task.actions,
        assigneeName:
          task.executorNickName || task.executorUsername || "未分配",
        assigneeAvatar: task.executorAvatar || "",
      };
    },
    formatExecTime(start, end) {
      if (!start) return "--";
      const startStr = dayjs(start).format("MM月DD日 HH:mm");
      if (!end || start === end) {
        return startStr;
      }
      return `${dayjs(end).format("MM月DD日 HH:mm")}`;
    },
    handleTaskDialogSuccess() {
      this.fetchTaskList();
    },
    // 开始操作统计轮询
    startOperationStatsPolling() {
      // 每30秒轮询一次
      this.operationStatsTimer = setInterval(() => {
        this.fetchOperationStats();
      }, 30000);
    },
    // 获取今日登录操作次数统计
    async fetchOperationStats() {
      try {
        const res = await getTodayOperationStatistics();
        if (res.code === 200 && res.data) {
          // 更新第4个统计卡片（今日登录操作次数）
          this.stats[3].value = res.data.todayCount || 0;

          // 计算趋势类型和显示文本
          const rate = res.data.rate || 0;
          const trendType = rate >= 0 ? "up" : "down";
          const trendValue = rate >= 0 ? `+${rate}%` : `${rate}%`;

          this.stats[3].trend = {
            type: trendType,
            value: trendValue,
            label: "较昨日",
          };
        }
      } catch (error) {
        console.error("获取今日登录操作次数统计失败:", error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.workbench-container {
  width: 100%;
  min-height: 100vh;
  background: #030a2e;
}

.workbench-content {
  padding: 20px;
}

// 统计卡片区域
.stats-section {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}

.stat-card {
  width: 445px;
  background: rgba(0, 32, 67, 0.6);
  border: 1px solid rgba(6, 145, 237, 0.6);
  box-shadow: 0 0 20px rgba(6, 145, 237, 0.4),
    inset 0px 0px 14px 0px rgba(6, 145, 237, 0.2);
  border-radius: 4px;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 233px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    border-color: rgba(6, 145, 237, 0.8);
    box-shadow: 0 0 30px rgba(6, 145, 237, 0.5),
      inset 0px 0px 14px 0px rgba(6, 145, 237, 0.3);
  }

  .stat-header {
    display: flex;
    align-items: flex-start;
    gap: 15px;
    flex: 1;
  }

  .stat-icon-wrapper {
    position: relative;
    width: 130px;
    height: 125px;
    flex-shrink: 0;

    .stat-icon-bg {
      position: absolute;
      width: 100%;
      height: 100%;
    }

    .stat-icon {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        filter: drop-shadow(0 0 4px rgba(149, 210, 240, 0.8));
      }
    }
  }

  .stat-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .stat-value {
      font-size: 40px;
      font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
      font-weight: 400;
      color: #fff;
      text-shadow: 0 0 10px rgba(149, 210, 240, 0.8),
        0 0 20px rgba(149, 210, 240, 0.4);
      margin-bottom: 8px;
      line-height: 1;
    }

    .stat-label {
      font-size: 22px;
      color: #ffffff;
      background: linear-gradient(90deg, #ffffff 0%, #0691ed 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      font-weight: 500;
      line-height: 1.2;
    }
  }

  .stat-footer {
    display: flex;
    gap: 20px;
    margin-top: 10px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    flex-wrap: wrap;

    .status-item {
      display: flex;
      align-items: flex-end;
      gap: 8px;
      font-weight: 500;

      .status-label {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #b6bcc7;
      }

      .status-value {
        font-weight: 400;
        font-size: 40px;
      }

      &.normal {
        .status-value {
          color: #00ff88;
        }
      }

      &.offline {
        .status-value {
          color: #ff4444;
        }
      }

      &.locked {
        .status-value {
          color: #2680dd;
        }
      }
    }

    // 趋势数据样式
    &.trend-footer {
      .trend-item {
        display: flex;
        align-items: center;
        gap: 8px;

        .trend-icon {
          width: 20px;
          height: 20px;
          margin-top: 20px;
        }

        .trend-value {
          font-size: 18px;
          font-weight: 600;
          margin-top: 20px;

          &.up {
            color: #ff4444;
          }

          &.down {
            color: #00ff88;
          }
        }

        &.up .trend-icon {
          color: #ff4444;
        }

        &.down .trend-icon {
          color: #00ff88;
        }

        .trend-label {
          margin-top: 20px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-size: 18px;
          font-weight: 400;
          color: #b6bcc7;
        }
      }
    }
  }
}

// 主要内容区域
.main-content {
  display: flex;
  justify-content: space-between;
  height: calc(100vh - 96px - 275px); // 减去Header和统计卡片区域高度
}

.panel-card {
  background: rgba(0, 32, 67, 0.6);
  box-shadow: inset 0px 0px 14px 0px #0691ed;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.section-title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
  text-shadow: 0px 0px 8px #1286ff;
  text-indent: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .view-all {
    font-size: 16px;
    color: #b6bcc7;
    font-weight: 400;
    cursor: pointer;
    margin-right: 20px;

    &:hover {
      color: #0691ed;
    }
  }
}

// 左侧：待办农事任务
.left-panel {
  width: calc(100vw - 446px - 20px - 50px);

  .task-grid {
    flex: 1;
    padding: 22px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 20px;
    overflow-y: auto;
  }

  .task-item {
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    background: url("../assets/img/workbench/card1.png") no-repeat center center;
    background-size: 100% 100%;

    .task-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 42px;
      padding-right: 7px;
      background: linear-gradient(90deg,
          #2680dd 0%,
          rgba(38, 128, 221, 0) 100%);
      text-indent: 20px;

      .task-title-section {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1;

        .task-urgency {
          border-radius: 4px;
          font-size: 16px;
          font-weight: 600;
          color: #ffffff;
          white-space: nowrap;
        }

        .task-name {
          font-size: 16px;
          font-weight: 600;
          color: #ffffff;
          flex: 1;
        }
      }

      .task-time {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        white-space: nowrap;
      }
    }

    .task-content {
      flex: 1;
      min-height: 98px;
      padding: 0 13px;

      .task-desc {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.85);
        line-height: 1.6;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }

    .task-footer {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 0 20px;
      height: 50px;

      .task-assignee {
        display: flex;
        align-items: center;
        gap: 8px;

        .assignee-avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          overflow: hidden;
          flex-shrink: 0;
          background: rgba(6, 145, 237, 0.3);
          border: 1px solid rgba(6, 145, 237, 0.5);

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .avatar-placeholder {
            width: 100%;
            height: 100%;
            background: linear-gradient(135deg, #0691ed 0%, #2680dd 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-size: 14px;
            font-weight: 600;
          }
        }

        .assignee-name {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.9);
          font-weight: 500;
        }
      }

      .execute-btn {
        background: linear-gradient(135deg, #2680dd 0%, #0691ed 100%);
        border: none;
        border-radius: 4px;
        padding: 8px 20px;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(6, 145, 237, 0.3);

        &:hover {
          background: linear-gradient(135deg, #0691ed 0%, #2680dd 100%);
          box-shadow: 0 4px 12px rgba(6, 145, 237, 0.5);
          transform: translateY(-1px);
        }

        &:active {
          transform: translateY(0);
        }
      }
    }
  }
}

// 右侧：近期操作日志
.right-panel {
  width: 446px;

  .log-list {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .log-item {
    width: 405px;
    height: 94px;
    background: url("../assets/img/workbench/info_bg.png") no-repeat center center;
    background-size: 100% 100%;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 0 15px;
    position: relative;

    .log-icon {
      width: 60px;
      height: 60px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .log-content-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 8px;
      min-width: 0;

      .log-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;

        .log-title {
          font-size: 18px;
          font-weight: 600;
          color: #ffffff;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .log-time {
          font-size: 14px;
          color: #ffffff;
          white-space: nowrap;
          flex-shrink: 0;
        }
      }

      .log-desc {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.85);
        line-height: 1.4;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }
}

.empty-state {
  flex: 1;
  min-height: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #7fb4ff;
  text-align: center;
  padding: 20px 0;
  gap: 12px;

  img {
    width: 160px;
    height: auto;
  }

  .empty-text {
    font-size: 16px;
    letter-spacing: 1px;
  }
}

// 滚动条样式
.task-grid::-webkit-scrollbar,
.log-list::-webkit-scrollbar {
  width: 6px;
}

.task-grid::-webkit-scrollbar-track,
.log-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

.task-grid::-webkit-scrollbar-thumb,
.log-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;

  &:hover {
    background: rgba(255, 255, 255, 0.5);
  }
}
</style>
